"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactTable = require("react-table");

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _faChevronUp = require("@fortawesome/pro-regular-svg-icons/faChevronUp");

var _faChevronDown = require("@fortawesome/pro-regular-svg-icons/faChevronDown");

var _faMeh = require("@fortawesome/pro-regular-svg-icons/faMeh");

var _index = _interopRequireDefault(require("./Filters/index"));

var _index2 = _interopRequireDefault(require("./Pagination/index"));

var _RowCountPicker = _interopRequireDefault(require("./RowCountPicker"));

var _index3 = _interopRequireDefault(require("./ColumnSelector/index"));

var _EditRows = _interopRequireDefault(require("./EditRows"));

var _peractoUi = require("@peracto/peracto-ui");

var S = _interopRequireWildcard(require("./styled"));

var _excluded = ["className", "renderColumnSelector", "renderFilters", "renderPagination", "renderRowCountPicker", "fetchData", "state", "currentFilters", "loading", "noResultsMessage", "fixedRowCount", "showPagination", "actionPanelContent", "allowDuplicate"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

var renderHeader = function renderHeader(_ref) {
  var headers = _ref.headers;
  return /*#__PURE__*/_react["default"].createElement("tr", null, headers.map(function (header, i) {
    return /*#__PURE__*/_react["default"].createElement(_react.Fragment, {
      key: i
    }, header.show && /*#__PURE__*/_react["default"].createElement("th", _extends({}, header.getHeaderProps(header.getSortByToggleProps()), {
      "data-testid": "header-".concat(i)
    }), header.render('Header'), header.isSorted ? header.isSortedDesc ? /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: _faChevronDown.faChevronDown,
      className: "ml-2"
    }) : /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: _faChevronUp.faChevronUp,
      className: "ml-2"
    }) : ''));
  }));
};

var renderRow = function renderRow(row, i) {
  return /*#__PURE__*/_react["default"].createElement("tr", _extends({}, row.getRowProps(), {
    className: (0, _classnames["default"])({
      selected: row.isSelected
    }),
    key: "row_".concat(i)
  }), row.cells.map(function (cell, i) {
    return /*#__PURE__*/_react["default"].createElement("td", _extends({
      key: i
    }, cell.getCellProps(), {
      "data-testid": typeof cell.row.cells[i].column.Header === 'string' ? "row-".concat(cell.row.index, "-").concat(cell.row.cells[i].column.Header.toString().toLowerCase().replaceAll(' ', '-')) : null
    }), cell.render('Cell'));
  }));
};

var renderRows = function renderRows(_ref2) {
  var page = _ref2.page,
      prepareRow = _ref2.prepareRow;
  return page && page.length ? page.map(function (row, i) {
    prepareRow(row);
    return renderRow(row, i);
  }) : null;
};

var defaults = {
  manualSorting: true,
  // Manual sorting
  manualFilters: true,
  // Manual filters
  manualPagination: true,
  // Manual pagination
  disableMultiSort: true,
  // Disable multi-sort
  disableGrouping: true,
  // Disable grouping
  disablePageResetOnDataChange: true,
  autoResetSortBy: false
};

var Table = function Table(_ref3) {
  var _ref3$className = _ref3.className,
      className = _ref3$className === void 0 ? 'table' : _ref3$className,
      _ref3$renderColumnSel = _ref3.renderColumnSelector,
      renderColumnSelector = _ref3$renderColumnSel === void 0 ? function (instance, props) {
    return /*#__PURE__*/_react["default"].createElement(_index3["default"], _extends({
      instance: instance
    }, props));
  } : _ref3$renderColumnSel,
      _ref3$renderFilters = _ref3.renderFilters,
      renderFilters = _ref3$renderFilters === void 0 ? function (instance, props) {
    return /*#__PURE__*/_react["default"].createElement(_index["default"], _extends({
      instance: instance
    }, props));
  } : _ref3$renderFilters,
      _ref3$renderPaginatio = _ref3.renderPagination,
      renderPagination = _ref3$renderPaginatio === void 0 ? function (instance, props) {
    return /*#__PURE__*/_react["default"].createElement(_index2["default"], _extends({
      instance: instance
    }, props));
  } : _ref3$renderPaginatio,
      _ref3$renderRowCountP = _ref3.renderRowCountPicker,
      renderRowCountPicker = _ref3$renderRowCountP === void 0 ? function (instance, props) {
    return /*#__PURE__*/_react["default"].createElement(_RowCountPicker["default"], _extends({
      instance: instance
    }, props));
  } : _ref3$renderRowCountP,
      fetchData = _ref3.fetchData,
      state = _ref3.state,
      _ref3$currentFilters = _ref3.currentFilters,
      currentFilters = _ref3$currentFilters === void 0 ? {} : _ref3$currentFilters,
      loading = _ref3.loading,
      noResultsMessage = _ref3.noResultsMessage,
      fixedRowCount = _ref3.fixedRowCount,
      _ref3$showPagination = _ref3.showPagination,
      showPagination = _ref3$showPagination === void 0 ? true : _ref3$showPagination,
      _ref3$actionPanelCont = _ref3.actionPanelContent,
      actionPanelContent = _ref3$actionPanelCont === void 0 ? null : _ref3$actionPanelCont,
      _ref3$allowDuplicate = _ref3.allowDuplicate,
      allowDuplicate = _ref3$allowDuplicate === void 0 ? false : _ref3$allowDuplicate,
      props = _objectWithoutProperties(_ref3, _excluded);

  var _state = _slicedToArray(state, 1),
      _state$ = _state[0],
      sortBy = _state$.sortBy,
      pageIndex = _state$.pageIndex,
      pageSize = _state$.pageSize,
      selectedRows = _state$.selectedRows;

  var ActionPanelContent = actionPanelContent || _EditRows["default"];
  (0, _react.useEffect)(function () {
    fetchData(state[0]);
  }, [sortBy, pageIndex, pageSize]);
  var instance = (0, _reactTable.useTable)(_objectSpread(_objectSpread(_objectSpread({}, defaults), props), {}, {
    state: state,
    manualSorting: true,
    currentFilters: currentFilters,
    getRowID: function getRowID(row, index) {
      return row.hasOwnProperty('originId') ? row.originId : row !== null && row !== void 0 && row.id ? row.id : pageIndex * pageSize + index;
    }
  }), _reactTable.useFilters, _reactTable.useSortBy, _reactTable.usePagination, _reactTable.useRowSelect);

  var hasFiltersApplied = function hasFiltersApplied() {
    var filterValues = Object.values(currentFilters);
    return filterValues.filter(function (val) {
      return val && val.length > 0;
    }).length > 0;
  };

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, renderFilters(instance, props), !loading && instance.numberOfRows === 0 ? /*#__PURE__*/_react["default"].createElement(S.NoResultsContainer, null, noResultsMessage ? noResultsMessage : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faMeh.faMeh,
    size: "6x",
    className: "mb-3"
  }), /*#__PURE__*/_react["default"].createElement("p", null, "No results found ", hasFiltersApplied && ' for the filters applied'))) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(S.TableContainer, null, /*#__PURE__*/_react["default"].createElement("table", _extends({}, instance.getTableProps(), {
    className: className
  }), /*#__PURE__*/_react["default"].createElement("thead", null, renderHeader(instance)), /*#__PURE__*/_react["default"].createElement("tbody", null, renderRows(instance))), /*#__PURE__*/_react["default"].createElement(_peractoUi.ActionPanel, {
    isVisible: selectedRows.length > 0
  }, /*#__PURE__*/_react["default"].createElement(ActionPanelContent, {
    instance: instance,
    selectedRows: selectedRows,
    reloadData: function reloadData() {
      return fetchData(state[0]);
    },
    allowDuplicate: allowDuplicate
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "d-flex flex-column flex-md-row align-items-center justify-content-between"
  }, renderColumnSelector(instance, props), showPagination && renderPagination(instance, props), !!fixedRowCount === false && showPagination ? renderRowCountPicker(instance, props) : /*#__PURE__*/_react["default"].createElement("div", null))));
};

var _default = Table;
exports["default"] = _default;